<template>
    <div class="container">
        <div class="" v-for="(tracking, index) in trackingData" :key="index">
            <shipment-details :tracking="tracking" />
            <shipment-timeline
                @toggleJourney="showJourney = !showJourney"
                :tracking="tracking"
            />
            <shipment-journey v-if="showJourney" :tracking="tracking" />
        </div>
        <div class="track-another" style="text-align: center">
            <button
                class="button is-link track-another-btn"
                @click="trackMore"
                style="margin-top: 30px"
            >
                Track Another
            </button>
        </div>
    </div>
</template>

<script>
import ShipmentDetails from "./ShipmentDetails";
import ShipmentJourney from "./ShipmentJourney";
import ShipmentTimeline from "./ShipmentTimeline";
export default {
    components: {
        "shipment-details": ShipmentDetails,
        "shipment-journey": ShipmentJourney,
        "shipment-timeline": ShipmentTimeline
    },
    props: {
        trackingData: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            availableActions: {
                manifested: 1020,
                inTransit: 1220,
                dispatched: 1700,
                delivered: 1900
            },
            showJourney: false
        };
    },
    methods: {
        trackMore() {
            this.$emit("trackMore");
        },
        isManifested(shipmentNo) {
            let availableActions = JSON.parse(
                JSON.stringify(this.availableActions)
            );
            availableActions = Object.values(availableActions);

            for (const event of this.trackingData[shipmentNo]["trackings"]) {
                if (availableActions.indexOf(event.status_code) > -1) {
                    return true;
                }
            }

            return false;
        },
        isInTransit(shipmentNo) {
            let availableActions = JSON.parse(
                JSON.stringify(this.availableActions)
            );
            delete availableActions["manifested"];
            availableActions = Object.values(availableActions);
            for (const event of this.trackingData[shipmentNo]["trackings"]) {
                if (availableActions.indexOf(event.status_code) > -1) {
                    return true;
                }
            }

            return false;
        },
        isDispatched(shipmentNo) {
            let availableActions = JSON.parse(
                JSON.stringify(this.availableActions)
            );
            delete availableActions["manifested"];
            delete availableActions["inTransit"];
            availableActions = Object.values(availableActions);
            for (const event of this.trackingData[shipmentNo]["trackings"]) {
                if (availableActions.indexOf(event.status_code) > -1) {
                    return true;
                }
            }

            return false;
        },
        isDelivered(shipmentNo) {
            let availableActions = JSON.parse(
                JSON.stringify(this.availableActions)
            );
            delete availableActions["manifested"];
            delete availableActions["inTransit"];
            delete availableActions["dispatched"];

            availableActions = Object.values(availableActions);
            for (const event of this.trackingData[shipmentNo]["trackings"]) {
                if (availableActions.indexOf(event.status_code) > -1) {
                    return true;
                }
            }

            return false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/TrackingDetails.vue